/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEditorAlfavit: {
  name: 'editor-alfavit';
  data: string;
} = {
  name: 'editor-alfavit',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="m8.447.776 4.999 9.998.003.006 1.998 3.996a.5.5 0 1 1-.894.448L12.69 11.5H3.31l-1.862 3.724a.5.5 0 1 1-.894-.448l1.993-3.986a.54.54 0 0 1 .013-.026L7.553.776a.5.5 0 0 1 .894 0Zm3.744 9.724-4.19-8.382L3.808 10.5h8.382Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
